import React from 'react'
import { Link } from 'gatsby'
import { SocialIcon } from 'react-social-icons'

const Footer = () => {
  let dot = (
    <span style={{ color: 'white', marginLeft: '4px', marginRight: '4px' }}>
      •
    </span>
  )

  return (
    <nav>
      <footer>
        <p>
          <Link to="/">Home</Link>
          {dot}

          <Link to="/about/">About</Link>
          {dot}

          <Link to="/privacy/">Privacy</Link>
          {dot}

          <Link to="/terms/">Terms</Link>
        </p>
      </footer>
      <div style={{ textAlign: 'center' }}>
        <SocialIcon
          network="twitter"
          bgColor="transparent"
          fgColor="lightblue"
          url="https://twitter.com/CountVax"
        />
      </div>
      <p>© Copyright covidvaxcount</p>
    </nav>
  )
}

export default Footer
